import { useEffect, useState } from 'react';
import './LoginWindow.css';
import logo from '../refs/logo.jpg'
import loginText from '../refs/login.png'
import userDataService from '../Services/UserService';

const sendForgotPasswordEmail = (email, setSuccess, setError, clearForgotPasswordMessage) => {
    userDataService.forgotPassword(email).then(response => {
        console.log(response)
        if(response.status > 199 && response.status < 300) setSuccess(true);
        else setError('No user with that email address is registered. Please contact support if you need further assistance.');
        clearForgotPasswordMessage();
    }).catch(e => {
        setError('No user with that email address is registered. Please contact support if you need further assistance.');
        clearForgotPasswordMessage();
    });
};

const ForgotPasswordWindow = ({ forgotPasswordSubmitting, handleForgotPassword, forgotPasswordEmail, setForgotPasswordEmail, submitForgotPassword, forgotPasswordError, forgotPasswordSuccess, forgotPasswordSuccessMessage }) => {
    return (
        <div className='Forgot-Password-Window'>
            <div className='Input-Box'>
                <label className='Input-Label'>
                    Email
                </label>
                <input
                    className='Input-Field'
                    type="email"
                    placeholder="Enter your email"
                    value={forgotPasswordEmail}
                    onChange={(e) => setForgotPasswordEmail(e.target.value)}
                    disabled={forgotPasswordSubmitting}
                />
            </div>
            {forgotPasswordError && 
                <label className='Forgot-Password-Message'>{forgotPasswordError}</label>
            }
            {forgotPasswordSuccess && 
                <label className='Forgot-Password-Message' style={{color: 'green'}}>{forgotPasswordSuccessMessage}</label>
            }
            {   forgotPasswordSubmitting &&
                <button className='Login-button'>
                    Submitting...
                </button>
            }
            {   !forgotPasswordSubmitting &&
                <button className='Login-button' onClick={submitForgotPassword}>
                    Submit
                </button>
            }

            <label className='Forgot-Password-Button' onClick={e => handleForgotPassword()}>Go Back to Sign In</label>
        </div>
    )
};

const LoginWindow = props => {
    const [ formUsername, setUsername] = useState("");
    const [ formPassword, setPassword] = useState("");
    const [ forgotPassword, setForgotPassword ] = useState(false);
    const [ forgotPasswordSubmitting, setForgotPasswordSubmitting ] = useState(false);
    const [ forgotPasswordEmail, setForgotPasswordEmail ] = useState("");
    const [ forgotPasswordError, setForgotPasswordError ] = useState("");
    const [ forgotPasswordSuccess, setForgotPasswordSuccess ] = useState(false);

    const login = () => {
        props.login({email:formUsername, password:formPassword});
    }

    const handleKeyDown = (e) => {
        if(e.key === 'Enter'){
            login();
        }
    }
    const sleep = ms => new Promise(r => setTimeout(r, ms));

    const forgotPasswordSuccessMessage = "A password reset link has been sent to the registered email address.";

    const clearForgotPasswordMessage = () => {
        setTimeout(() => {
                setForgotPasswordError("");
                setForgotPasswordSuccess(false);
                setForgotPasswordSubmitting(false);
                setForgotPassword(false);
            }, 3000);
    };

    const handleForgotPassword = () => {
        setForgotPassword(!forgotPassword);
    };

    const toggleRemeberMe = () => {
        props.setRememberMe(!props.rememberMe);
        console.log(props.rememberMe);
    };

    const submitForgotPassword = async () => {
        if(forgotPasswordEmail){
            setForgotPasswordSubmitting(true);  
            sendForgotPasswordEmail(forgotPasswordEmail, setForgotPasswordSuccess, setForgotPasswordError, clearForgotPasswordMessage);
        }
    };

    return (
        <div className='Login-Window'>
            <div className="Login-Box">
                <img src={logo} className="Login-Image"/>
                <img src={loginText} className="Login-Image-Text"/>
                {   !forgotPassword &&
                    <>
                    <div className='Input-Box'>
                        <label className='Input-Label'>
                            Email
                        </label>
                        <input
                            className='Input-Field'
                            type="text"
                            placeholder=""
                            onKeyDown={((e) => handleKeyDown(e))}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className='Input-Box'>
                        <label className='Input-Label'>
                            Password
                        </label>
                        <input
                        className='Input-Field'
                        type="password"
                        placeholder=""
                        onKeyDown={((e) => handleKeyDown(e))}
                        onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    {props.loginError && 
                        <label className='Login-In-Error-Message'> Incorrect Username or Password </label>
                    }
                    <div className='Checkbox-Box'>
                        <input type="checkbox" className='Checkbox-Input' onClick={e => toggleRemeberMe()}/>
                        <label className='Checkbox-Label' >
                            Remember me
                        </label>
                    </div>
                    <button className='Login-button' onClick={login} >
                        Login
                    </button>
                    <label className='Forgot-Password-Button' onClick={e => handleForgotPassword()}>Forgot my Password</label>
                    </>
                }
                
                {   forgotPassword &&
                    <ForgotPasswordWindow 
                        forgotPasswordSubmitting={forgotPasswordSubmitting}
                        handleForgotPassword={handleForgotPassword}
                        forgotPasswordEmail={forgotPasswordEmail}
                        setForgotPasswordEmail={setForgotPasswordEmail}
                        submitForgotPassword={submitForgotPassword}
                        forgotPasswordError={forgotPasswordError}
                        forgotPasswordSuccess={forgotPasswordSuccess}
                        forgotPasswordSuccessMessage={forgotPasswordSuccessMessage}
                    />
                }
                
            </div>
        </div>
    );
}

export default LoginWindow;